import { useRouter } from 'next/router';

export const redirectPath = () => {
  const { asPath = '', locale = '' } = useRouter();

  const redirectPath = `${locale === 'uk' ? '' : `/${locale}`}${asPath}`;

  return redirectPath;
};
